<div class="fields-item-wrapper" *ngIf="formGroup" [formGroup]="formGroup">
  <div class="details flex-1">
    <ng-container *ngIf="canEdit; else viewFields">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['label']"
        [parentFormGroup]="formGroup"
        class="w-full mb-[20px]"
        controlName="label"
        label="Label"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['name']"
        [parentFormGroup]="formGroup"
        class="w-full mb-[20px]"
        controlName="name"
        label="Name"
      />
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['type']"
        [options]="typeOptions"
        [parentFormGroup]="formGroup"
        [placeholder]="'Select'"
        class="w-full mb-[20px]"
        controlName="type"
        label="Type"
      />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['uom']"
        [parentFormGroup]="formGroup"
        class="w-full mb-[20px]"
        controlName="uom"
        label="UOM"
      />

      <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
        <div class="label text-type-13 uppercase">Is Optional</div>
        <mat-slide-toggle
          formControlName="isOptional"
          (change)="onIsOptionalToggle($event)"
          [disableRipple]="false"
          class="slide-toggle-btn"
          color="primary"
        ></mat-slide-toggle>
      </div>

      <div class="validation-section mb-[40px]">
        <div class="validation-heading">Validations</div>
        <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
          <div class="label text-type-13 uppercase">Required</div>
          <mat-slide-toggle
            formControlName="required"
            (change)="onRequiredToggle($event)"
            [disableRipple]="false"
            class="slide-toggle-btn"
            color="primary"
          ></mat-slide-toggle>
        </div>
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['required_min']"
          [parentFormGroup]="formGroup"
          class="w-full mb-[20px]"
          controlName="required_min"
          label="Min"
        />
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['required_max']"
          [parentFormGroup]="formGroup"
          class="w-full mb-[20px]"
          controlName="required_max"
          label="Max"
        />
      </div>

      <div class="range-section mb-[40px]">
        <div class="range-heading">Range</div>
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['range_min']"
          [parentFormGroup]="formGroup"
          class="w-full mb-[20px]"
          controlName="range_min"
          label="Min"
        />
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['range_max']"
          [parentFormGroup]="formGroup"
          class="w-full mb-[20px]"
          controlName="range_max"
          label="Max"
        />
      </div>
    </ng-container>
    <ng-template #viewFields>
      <app-view-field class="w-full mb-[20px]" [label]="'Label'" [value]="formGroup.get('label')?.value ?? ''" />
      <app-view-field class="w-full mb-[20px]" [label]="'Name'" [value]="formGroup.get('name')?.value ?? ''" />
      <app-view-field class="w-full mb-[20px]" [label]="'Type'" [value]="formGroup.get('type')?.value ?? ''" />
      <app-view-field class="w-full mb-[20px]" [label]="'UOM'" [value]="formGroup.get('uom')?.value ?? ''" />
      <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
        <div class="label text-type-13 uppercase">Is Optional</div>
        <mat-slide-toggle formControlName="isOptional" [disabled]="true" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <div class="validation-heading mb-[12px]">Validations</div>
      <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
        <div class="label text-type-13 uppercase">Required</div>
        <mat-slide-toggle formControlName="required" [disabled]="true" class="slide-toggle-btn" color="primary"></mat-slide-toggle>
      </div>
      <app-view-field class="w-full mb-[20px]" [label]="'Min'" [value]="formGroup.get('required_min')?.value ?? ''" />
      <app-view-field class="w-full mb-[20px]" [label]="'Max'" [value]="formGroup.get('required_max')?.value ?? ''" />
      <div class="range-heading mb-[12px]">Range</div>
      <app-view-field class="w-full mb-[20px]" [label]="'Min'" [value]="formGroup.get('range_min')?.value ?? ''" />
      <app-view-field class="w-full mb-[20px]" [label]="'Max'" [value]="formGroup.get('range_max')?.value ?? ''" />
    </ng-template>
  </div>
  <div *ngIf="canEdit" class="action-section w-full flex justify-center items-center mt-[24px]">
    <app-primary-button
      (handleClick)="onSubmit()"
      [isDisabled]="!formGroup?.dirty"
      class="w-full"
    >
      Submit
    </app-primary-button>
  </div>
</div>
